import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyCheckAddressRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyCheckAddressResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyCheckAddress = (request: VerifyCheckAddressRequest, options?: CashRequestOptions) =>
  post<VerifyCheckAddressRequest, VerifyCheckAddressResponse>('/2.0/cash/verify-check-address', request, {
    ...options,
    rejectOnError: true,
  })
